import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { logError, logWarning } from "@faire/web--source/common/logging";
import { isLoggingSettingUsageEnabled, trackSettingsAndExperiment } from "@faire/web--source/common/serialized-setting-tracker/SerializedSettingTracker";
import batchAssignSettingRequest from "@faire/web-api--source/api/v2/setting/batch_assign/post";
export var BATCH_SETTING_THROTTLE_MS = 1000;
/**
 * Assignment logic shared between the hook implementation and the legacy implementation of setting assignment.
 */ export var sharedAssignSetting = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(settingOrKey, options, cache, accumulator, throttledBatchAssignSetting) {
        var key;
        return _ts_generator(this, function(_state) {
            key = typeof settingOrKey === "string" ? settingOrKey : settingOrKey.name;
            if (accumulator.has(key) || cache.has(key)) {
                return [
                    2
                ];
            }
            accumulator.set(key, {
                setting: key,
                created_at: Date.now()
            });
            // Don't throttle when testing, adds unnecessary complexity
            if ((options === null || options === void 0 ? void 0 : options.submitImmediately) || "production" === "test" && !process.env.TEST_ASSIGNMENTS) {
                return [
                    2,
                    unthrottledBatchAssignSetting(cache, accumulator)
                ];
            }
            // We shouldn't await this bulkAssignment because it will get throttled
            return [
                2,
                throttledBatchAssignSetting(cache, accumulator)
            ];
        });
    });
    return function sharedAssignSetting(settingOrKey, options, cache, accumulator, throttledBatchAssignSetting) {
        return _ref.apply(this, arguments);
    };
}();
export var unthrottledBatchAssignSetting = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(cache, accumulator) {
        var assignments, keys, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    assignments = Array.from(accumulator.values());
                    accumulator.clear();
                    if (assignments.length === 0) {
                        return [
                            2
                        ];
                    }
                    keys = assignments.map(function(i) {
                        return i.setting;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    // we add to our cache before submitting the job to prevent a race condition
                    keys.forEach(function(key) {
                        return cache.add(key);
                    });
                    return [
                        4,
                        batchAssignSettingRequest({
                            assignments: assignments
                        })
                    ];
                case 2:
                    _state.sent();
                    if (isLoggingSettingUsageEnabled()) {
                        trackSettingsAndExperiment(keys, {
                            isAssignment: true
                        });
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    logWarning("Failed to assign ".concat(keys.join(", ")));
                    logError(error);
                    // if our request failed we assume the assignment did not work so we clear the keys
                    keys.forEach(function(key) {
                        return cache.delete(key);
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function unthrottledBatchAssignSetting(cache, accumulator) {
        return _ref.apply(this, arguments);
    };
}();
